const e = {
  default: {
    file: "theme_default.jpg",
    name: "Cobalt Blue"
  },
  blue: {
    file: "theme_blue.jpg",
    name: "Tanzanite Blue"
  },
  bluegreen: {
    file: "theme_blue_green.jpg",
    name: "Ocean Blue"
  },
  emerald: {
    file: "theme_emerald.jpg",
    name: "Emerald Green"
  },
  grey: {
    file: "theme_grey.jpg",
    name: "Concrete Grey"
  },
  orange: {
    file: "theme_orange.jpg",
    name: "Sunset Orange"
  },
  purple: {
    file: "theme_purple.jpg",
    name: "Amethyst Purple"
  },
  purplepink: {
    file: "theme_purple_pink.jpg",
    name: "Lotus Pink and Purple"
  },
  ruby: {
    file: "theme_ruby.jpg",
    name: "Ruby Red"
  },
  midnightblue: {
    file: "theme_midnight_blue.jpg",
    name: "Midnight Blue"
  },
  lightgreen: {
    file: "theme_light_green.jpg",
    name: "Leaf Green"
  },
  mauve: {
    file: "theme_mauve.jpg",
    name: "Mauve"
  },
  brightgreen: {
    file: "theme_bright_green.jpg",
    name: "Lime Green"
  },
  forestgreen: {
    file: "theme_forest_green.jpg",
    name: "Spruce Green"
  },
  dullpurple: {
    file: "theme_dull_purple.jpg",
    name: "Purple Haze"
  },
  pink: {
    file: "theme_pink.jpg",
    name: "Neon Pink"
  }
};
function m(n, t) {
  const l = t || window.paths.core_static, a = e[n] || e.default;
  return `${l}apps/students/images/theme-background/${a.file}`;
}
const r = {
  THEMES: e,
  themeImagePath: m
};
export {
  e as THEMES,
  r as default,
  m as themeImagePath
};
